import { config } from '../../Config';

const UpdateChatName = async (chatId, userId, newChatName, isManuallyRenamed = false) => {
    const url = config.updateChatName;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ chatId, userId, newChatName, isManuallyRenamed })
        });

        if (!response.ok) {
            throw new Error(`Failed to update chat name: ${response.statusText}`);
        }

        // console.log('Chat name updated successfully');
        return true;
    } catch (error) {
        // console.error('Error updating chat name:', error);
        return false;
    }
};

export default UpdateChatName;
